'use strict';

// Import Libraries
import React      from 'react';
import classNames from 'classnames';

// -----------------------------------------------------------
//  Spinner
// -----------------------------------------------------------
const Spinner = ({style, mini, className}) => {
  return (
    <div className={ classNames('spinner-backdrop', className) } style={ style }>
      <div data-test-id="spinner" className={ classNames('spinner', {'spinner-mini': mini}) } />
    </div>
  );
};

export default Spinner;
